import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, Globe2 } from "lucide-react";

const COUNTRIES = [
  { slug: "germany", name: "Germany" },
  { slug: "netherlands", name: "Netherlands" },
  { slug: "romania", name: "Romania" },
  { slug: "poland", name: "Poland" },
  { slug: "bulgaria", name: "Bulgaria" },
  { slug: "remote-europe", name: "Remote Europe" },
];

export default function Navbar() {
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-slate-200/70"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-slate-900 text-white grid place-items-center font-display font-black">
            E
          </div>
          <div className="font-display font-bold text-slate-900 tracking-tight">
            EuroAsia<span className="text-blue-600"> Recruiting</span>
            <span className="ml-2 text-[10px] font-mono-ui uppercase tracking-[0.2em] text-slate-500">
              Europe
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <a
            data-testid="nav-employers"
            href="#employers"
            className="px-3 py-2 text-sm text-slate-700 hover:text-slate-900"
          >
            Employers
          </a>
          <a
            data-testid="nav-candidates"
            href="#candidates"
            className="px-3 py-2 text-sm text-slate-700 hover:text-slate-900"
          >
            Candidates
          </a>
          <a
            data-testid="nav-services"
            href="#services"
            className="px-3 py-2 text-sm text-slate-700 hover:text-slate-900"
          >
            Services
          </a>
          <a
            data-testid="nav-tools"
            href="#tools"
            className="px-3 py-2 text-sm text-slate-700 hover:text-slate-900"
          >
            Tools
          </a>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                data-testid="nav-locations-trigger"
                className="px-3 py-2 text-sm text-slate-700 hover:text-slate-900 inline-flex items-center gap-1"
              >
                <Globe2 className="w-4 h-4" /> Locations
                <ChevronDown className="w-4 h-4" />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              {COUNTRIES.map((c) => (
                <DropdownMenuItem key={c.slug} asChild>
                  <Link
                    data-testid={`nav-location-${c.slug}`}
                    to={`/locations/${c.slug}`}
                  >
                    {c.name}
                  </Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </nav>

        <div className="flex items-center gap-2">
          <Button
            data-testid="nav-book-consultation"
            asChild
            className="bg-blue-600 hover:bg-blue-700 text-white"
          >
            <a href="#consultation">Book Consultation</a>
          </Button>
        </div>
      </div>
    </header>
  );
}
